// States were insurance is not provided
const restrictedStates = ['CA', 'SC'];

export default restrictedStates;
